import { Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ComparisonCard from '../Cards/ComparisonCard';

const comparison = [
	{
		value: '+200',
		title: 'Checklists',
		description: 'com orientação dos professores',
		old: true,
	},
	{
		value: '+200',
		title: 'Estações',
		description: 'discutidas pelo professor',
		old: true,
	},
	{
		value: '+150',
		title: 'casos temáticos',
		old: true,
	},
	{
		value: '+30',
		title: 'estações em vídeos',
		old: true,
	},
	{
		value: '+20',
		title: 'vídeos de procedimento ',
		old: true,
	},
	{
		value: '1',
		title: 'estação com instrutor revalidado',
		old: true,
	},
	{
		placeholder: true,
		old: true,
	},
	{
		placeholder: true,
		old: true,
	},
	{
		placeholder: true,
		old: true,
	},
	{
		placeholder: true,
		old: true,
	},
	{
		placeholder: true,
		old: true,
	},

	{
		value: '+200',
		title: 'checklists',
		description: 'com orientação dos professores',
	},
	{
		value: '+200',
		title: 'estações',
		description: 'discutidas pelo professor',
	},
	{
		value: '+200',
		title: 'casos temáticos',
	},
	{
		value: '40',
		title: 'estações em vídeos',
	},
	{
		value: '+20',
		title: 'vídeos de procedimento',
	},
	{
		title: 'Estações e mentorias individuais com instrutor revalidado',
	},
	{
		value: '60',
		title: 'Apostas Hardwork',
		added: true,
	},
	{
		title: 'Revisões com flashcards',
		added: true,
	},
	{
		title: 'Mentoria individual',
		added: true,
	},
	{
		title: 'Mentoria semanal em grupo',
		added: true,
	},
	{
		title: 'Arena em dupla com convidado',
		added: true,
	},
];

export default function Comparison() {
	const classes = useStyles();
	const theme = useTheme();

	const matchesTablet = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<>
			<Grid
				item
				container
				style={{
					background: 'linear-gradient(180deg, #2C3931 0%, #151F1B 48%, #0D0D0D 100%)',
				}}
			>
				<Container
					fixed
					maxWidth="xl"
					disableGutters={true}
					className={'revalida'}
				>
					<Grid
						container
						className="section"
						style={{
							margin: '0 auto',
						}}
					>
						<Grid container>
							<Grid
								container
								className="section"
								style={{ margin: '0 auto' }}
							>
								<Grid
									container
									item
									className={classes.container}
									rowSpacing={4}
									columnSpacing={5}
									xs={12}
								>
									<Grid
										item
										container
										alignContent={'flex-start'}
										md={12}
										lg={6}
									>
										<Grid
											item
											xs={12}
											container
										>
											<Typography
												className={classes.title}
												fontFamily={'Bebas Neue'}
											>
												O ARENA JÁ ERA BOM...
											</Typography>
										</Grid>

										<Grid
											xs={12}
											container
											item
											spacing={matchesTablet ? 1 : 2}
										>
											{comparison
												.filter((f) => f.old && !f.placeholder)
												.map((item, index) => (
													<Grid
														key={index}
														item
														container
													>
														<ComparisonCard {...item} />
													</Grid>
												))}

											{!matchesTablet &&
												comparison
													.filter((f) => f.placeholder)
													.map((item, index) => (
														<Grid
															key={index}
															item
															container
														>
															<ComparisonCard {...item} />
														</Grid>
													))}
										</Grid>
									</Grid>

									<Grid
										item
										container
										alignContent={'flex-start'}
										md={12}
										lg={6}
									>
										<Grid
											item
											container
										>
											<Typography
												className={classes.title}
												fontFamily={'Bebas Neue'}
											>
												...Agora é imbatível!
											</Typography>
										</Grid>

										<Grid
											container
											item
											spacing={matchesTablet ? 1 : 2}
										>
											{comparison
												.filter((f) => !f.old)
												.map((item, index) => (
													<Grid
														key={index}
														item
														container
													>
														<ComparisonCard {...item} />
													</Grid>
												))}
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Container>
			</Grid>
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	container: {
		margin: '40px 0 64px !important',
		[theme.breakpoints.down('md')]: {
			margin: '24px 0 !important',
		},
	},
	title: {
		width: '100%',
		color: '#FCFCFC',
		textAlign: 'center',
		fontSize: '3rem !important',
		marginBottom: '24px !important',
		[theme.breakpoints.down('md')]: {
			lineHeight: 'unset !important',
			marginBottom: '16px !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.6rem !important',
			lineHeight: 'unset !important',
		},
	},
}));
